import * as React from 'react';
import { Route } from 'react-router-dom';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import Confirm from './Confirm';
import Lockout from './Lockout';
import LoginTwoFactor from './LoginTwoFactor';
import LoginRecovery from './LoginRecovery';
import ResetPassword from './ResetPassword';
import LoginTwoFactorSetup from './LoginTwoFactorSetup';
import DuoError, { DuoOffline } from './two-factor-providers/duo-security/DuoError';
import RegisterInstallation from './RegisterInstallation';
import EntraIdError, { EntraIdOffline } from './entraId/EntraIdError';
// #region Tosoh
import OpenIdError, { OpenIdOffline } from './openId/OpenIdError';
// #endregion Tosoh

/**
 * Routes related to the Login SPA application.
 */
export default (
	<>
		<Route exact path="/login" component={Login} />
		<Route exact path="/account/forgot-password" component={ForgotPassword} />
		<Route exact path="/account/reset-password" component={ResetPassword} />
		<Route exact path="/account/confirm" component={Confirm} />
		<Route exact path="/account/lockout" component={Lockout} />
		<Route exact path="/account/login-two-factor" component={LoginTwoFactor} />
		<Route exact path="/account/login-recovery" component={LoginRecovery} />
		<Route exact path="/account/two-factor-setup" component={LoginTwoFactorSetup} />
		<Route exact path="/account/duo-error" component={DuoError} />
		<Route exact path="/account/duo-offline" component={DuoOffline} />
		<Route exact path="/register-installation" component={RegisterInstallation} />
		<Route exact path="/account/entra-id-error" component={EntraIdError} />
		<Route exact path="/account/entra-id-offline" component={EntraIdOffline} />
		{/* #region Tosoh */}
		<Route exact path="/account/open-id-error" component={OpenIdError} />
		<Route exact path="/account/open-id-offline" component={OpenIdOffline} />
		{/* #endregion Tosoh */}
	</>
);
